// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.92.0-beta.de1a015ca',
  revision: 'de1a015ca',
  branch: 'develop',
  date: 'Fri, 23 Oct 2026 11:10:06 GMT'
};